import { dataSystemsAPI } from "./dataSystemsAPI";

/**
 * Creates RTK 'useQuery' hooks for the endpoints defined in the 'endpoints'
 * object.
 */
export const nicheItemEndpoints = dataSystemsAPI.injectEndpoints({
    reducerPath: "nicheItemEndpoints",
    overrideExisting: false,
    endpoints: (builder) => ({
        getPlacesByCategory: builder.query({
            query: ({ state, nicheItem, category, latitude, longitude }) => {
                let url = `/states/${state}/niches/${nicheItem}/categories/${category}?latitude=${latitude}&longitude=${longitude}`;
                return {
                    url,
                    method: "GET",
                };
            },
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPlacesByCategoryQuery } = nicheItemEndpoints;
